import { Component, Input, OnChanges } from "@angular/core";

import { clampProgressPercentage, progressBarColorClass } from "../../../utils/progress-bar-color.util";

/** The app's only progress bar. Bands come from `progressBarColorClass`; see that util before changing colours. */
@Component({
  standalone: false,
  selector: "app-progress-bar",
  templateUrl: "./progress-bar.component.html",
  // The host must carry a definite width: dropped into a flex cell it would otherwise size to the
  // label alone, leaving the track nothing to fill and collapsing it to zero.
  host: { class: "block w-full" }
})
export class ProgressBarComponent implements OnChanges {
  @Input() percentage: number | null | undefined = 0;
  /** Capped in a table so the NN% labels line up down the column; fluid where the bar owns its row. */
  @Input() fluid = false;
  @Input() caption = false;

  // Fields, not getters: a table renders one of these per row and the template reads each twice.
  value = 0;
  fillColorClass = "";
  trackWidthClass = "";
  labelClass = "";
  rowClass = "";

  ngOnChanges(): void {
    this.value = clampProgressPercentage(this.percentage);
    this.fillColorClass = progressBarColorClass(this.value);
    this.trackWidthClass = this.fluid ? "flex-1" : "sm:w-24 sm:shrink-0";
    const labelSize = this.caption ? "t-cap" : "t-body-bold";
    this.labelClass = `${labelSize} ${this.fluid ? "min-w-[35px]" : this.caption ? "min-w-[30px] sm:text-right" : "min-w-11 sm:text-right"}`;
    this.rowClass = this.fluid ? "sm:h-[28px]" : "";
  }
}
